import * as React from 'react';
import { connect } from 'react-redux';
import { CSSProperties } from 'react';
import { browserHistory } from 'react-router';
import Radium, { StyleRoot } from 'radium';
import * as Tgcc from '../tgccGlobal';
import * as Request from '../tgccRequest';

class Props {
    content: React.ReactNode; 
    children?: React.ReactNode; 
}

class Tooltip extends React.Component<Props, any>{
    state = {
        isVisible: false
    };

    showTooltip = () => {
        this.setState({ isVisible: true });
    };

    hideTooltip = () => {
        this.setState({ isVisible: false });
    };
    render() {
        const { isVisible } = this.state;
        const { children, content } = this.props;

        const tooltipStyle = {
            position: 'relative',
            display: 'inline-block',
            cursor: 'help',
        };

        const tooltipTextStyle = {
            visibility: isVisible ? 'visible' : 'hidden',
            width: '25vw',
            backgroundColor: 'black',
            color: '#fff',
            borderRadius: '6px',
            padding: '5px 0',
            position: 'absolute',
            zIndex: 1,
            bottom: '125%',
            left: '50%',
            marginLeft: '-80px',
            opacity: isVisible ? 1 : 0,
            transition: 'opacity 0.3s',
        };

        const tooltipArrowStyle = {
            position: 'absolute',
            top: '100%',
            left: '50%',
            marginLeft: '-5px',
            borderWidth: '5px',
            borderStyle: 'solid',
            borderColor: 'black transparent transparent transparent',
        };

        return (
            <div style={tooltipStyle}
                 onMouseEnter={this.showTooltip}
                 onMouseLeave={this.hideTooltip}>
                {children}
                <div style={tooltipTextStyle}>
                    {content}
                    <div style={tooltipArrowStyle} />
                </div>
            </div>
        );
    }
}

export default Tooltip;
